"use strict";
var GenerateReactClass_1 = require("./react-class-creation-and-runtime/GenerateReactClass");
exports.reactifyVue = function (reactifyVueArgs) {
    return GenerateReactClass_1.generateReactClass(reactifyVueArgs.instantiatedComponents, reactifyVueArgs.component, reactifyVueArgs.slots, reactifyVueArgs.tag, reactifyVueArgs.mixin, reactifyVueArgs.args);
};

//# sourceMappingURL=ReactifyVue.js.map



//////////////////
// WEBPACK FOOTER
// ./~/framework7-react/dist/src/utils/reactify-vue/ReactifyVue.js
// module id = 233
// module chunks = 0